package de.oevbs.kunde.kundenportal2.model.services.authentication

import de.oevbs.kunde.kundenportal2.PinAuthenticationStep
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import de.oevbs.kunde.kundenportal2.validation.validateUsingRegex
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class PartnerAuthentication(
    val dateOfBirth: LocalDate? = null,
    val contractNo: String = "",
    val partnerId: String = "",
) {

    companion object {
        val validation = validation<PartnerAuthentication, ComponentValidationMessage> { inspector ->

            val policyId = inspector.map(PartnerAuthentication.contractNo())
            addAll(
                policyId.validateUsingRegex(
                    Regexes.policyId,
                    emptyMessage = "Bitte geben Sie eine aktive Vertragsnummer ein."
                )
            )

            val partnerId = inspector.map(PartnerAuthentication.partnerId())
            addAll(partnerId.validateUsingRegex(Regexes.partnerId))

            val date = inspector.map(PartnerAuthentication.dateOfBirth())
            if (date.data == null) {
                add(date.errorMessage(KupoValidationMessages.EMPTY_INPUT))
            }
        }
    }
}

@Lenses
@Serializable
data class PinAuthentication(
    val pin: String = "",
    val crmMail: String = "",
    val accountMail: String = "",
    val selectedMail: String = "",
) {
    companion object {
        val validation = validation<PinAuthentication, PinAuthenticationStep, ComponentValidationMessage> { inspector, step ->
            when (step) {
                PinAuthenticationStep.CHECKPIN1 -> {
                    val inputCode = inspector.map(PinAuthentication.pin())
                    if (inputCode.data.isEmpty() || (inputCode.data.length != 6)) {
                        add(inputCode.errorMessage("Bitte geben Sie den 6-stelligen Freischaltcode aus dem zuletzt erhaltenen Brief ein."))
                    }
                }

                PinAuthenticationStep.SELECTMAIL2 -> {
                    val mail = inspector.map(PinAuthentication.selectedMail())
                    if (mail.data.isEmpty()) {
                        add(mail.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                    }
                }

                else -> println("Fehler: Unbekannter PinAuthentication Step im PinAuthenticationValidator.")
            }
        }
    }
}